import React from "react"
import { useAppDispatch, useAppSelector } from "../../../shared/hooks"
import { useTranslation } from "react-i18next"
import { FormTemplate } from "../../formTemplate/state/formTemplateTypes"
import DetailsCardInner from "../../../shared/components/layout/detailsCard/DetailsCardInner"
import IconCircleContainer from "../../../shared/components/icons/IconCircleContainer"
import { IconPathway } from "../../../svg/icons"
import DetailsCardRight from "../../../shared/components/layout/detailsCard/DetailsCardRight"
import DetailsCardButtons from "../../../shared/components/layout/detailsCard/DetailsCardButtons"
import TimeDefaultFormat from "../../../shared/components/time/TimeDefaultFormat"
import Button from "../../../shared/components/buttons/Button"
import { createFormForCaseAction } from "../state/addFormToCaseActions"
import { StyleVariants } from "../../../shared/state/sharedTypes"
import { useParams } from "react-router"
import { IHaveMeetingCaseId } from "../../meetingCase/state/meetingCaseTypes"

interface Props {
  caseId: string
  handleClose: () => void
  formTemplateId: string
  setPreviewingTemplateId: (id: string) => void
}

const AddFormToCaseListItem: React.FC<Props> = (props) => {
  const { t } = useTranslation(["forms"])
  const dispatch = useAppDispatch()
  const { meetingCaseId } = useParams<IHaveMeetingCaseId>()
  const formTemplate: FormTemplate = useAppSelector((state) => state.entities.formTemplates.byId[props.formTemplateId])
  const addForm = () => {
    console.log(meetingCaseId)
    dispatch(createFormForCaseAction(props.caseId, props.formTemplateId, meetingCaseId))
    props.handleClose()
  }

  return <li>
    <div className="border border-ch-gray-400 rounded-md p-4 mb-2">
      <div className="flex items-center flex-wrap justify-center lg:justify-between md:flex-nowrap mb-2">
        <DetailsCardInner>
          <IconCircleContainer className="sm:mr-4">
            <IconPathway className="fill-current w-6 h-6" />
          </IconCircleContainer>

          <div className="flex-1 lg:grid grid-cols-2 gap-3">
            <ul className="col-span-1">
              <li>
                <b>{formTemplate.name}</b>
              </li>
              <li>
                {t("shared:lastUpdated")}: <TimeDefaultFormat utcTime={formTemplate.updatedAt} />
              </li>
            </ul>
            <ul className="col-span-1">
              <li>
                {t("forms:formTemplate:description")}: {formTemplate.description}
              </li>
            </ul>
          </div>
        </DetailsCardInner>

        <DetailsCardRight>
          <DetailsCardButtons
            className="items-center"
            buttons={[
              <Button key="1" action={addForm} variant={StyleVariants.BLUE}>{t("forms:addFormToCase:buttons:add") }
              </Button>,
              <Button
                key="2"
                action={() => props.setPreviewingTemplateId(props.formTemplateId)}
                variant={StyleVariants.BLUE_ALT}
              >
                {t("forms:addFormToCase:buttons:preview")}
              </Button>
            ]}
          />
        </DetailsCardRight>
      </div>
    </div>
  </li>
}

export default AddFormToCaseListItem
